import {
  GET_SHOPPING_AREAS,
  GET_SHOPPING_AREAS_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  shoppingAreas: [],
}

const ShoppingAreasList = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHOPPING_AREAS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SHOPPING_AREAS_SUCCESS:
      state = {
        ...state,
        shoppingAreas: action.payload.shoppingAreas,
        loading: false,
        done: true,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default ShoppingAreasList
